import Notification from "@/services/echo-manager/notification";

export default class MemberKicked extends Notification
{
    handle() {
        //
    }
}